import { Box, Divider, useMantineTheme } from '@mantine/core';
import { memo } from 'react';

export const AuthFooter = memo(
	({
		children,
		mt = 'xl',
		denyMargin = '2xl',
	}: {
		children: React.ReactNode;
		mt?: string;
		denyMargin?: string | false;
	}) => {
		const theme = useMantineTheme();

		return (
			<Box
				mt={mt}
				style={{
					marginBottom: denyMargin
						? `calc(${theme.spacing[denyMargin]} * -1)`
						: undefined,
					marginLeft: denyMargin
						? `calc(${theme.spacing[denyMargin]} * -1)`
						: undefined,
					marginRight: denyMargin
						? `calc(${theme.spacing[denyMargin]} * -1)`
						: undefined,
				}}
			>
				<Divider />
				{children}
			</Box>
		);
	}
);
